<template>
  <a class="seat href-btn" v-on:click="selectSeat()">
    <span class="icon-holder" v-if="this.seatData.userCanDelete">
      <span class="icon">
        <i class="fas fa-times"></i>
        <span class="badge"></span>
      </span>
    </span>
    <span class="seat-shape" v-bind:class="[this.getCss(this.seatData.seatStatus)]">
      <span class="text">{{ this.seatData.code }}</span>
    </span>

    <!-- <div class=""></div> -->
  </a>
</template>

<script>
/* eslint-disable */

export default {
  name: "SeatItem",
  props: {
    showBookSeatDialog: {
      type: Boolean,
      default: () => false
    },
    seatData: { required: true, type: Object, default: () => {} },
    itemRow: { required: true, type: Number, default: () => 0 },
    itemColumn: { required: true, type: Number, default: () => 0 }
    //content: { required: true, type: String, default: () => "" }
  },
  data() {
    return {};
  },
  methods: {
    getCss(status) {
      switch (status) {
        case 0:
          return "unavailable";
        case 1:
          return "available";
        case 3:
          return "reserved-by-user";
        case 4:
          return "in-progress";
        default:
          return "reserved";
      }
    },
    selectSeat() {
      //if (this.seatData.seatStatus != 1) return;
      //console.log("selected: ", this.seatData.code);

      //this.$emit("update", "seats", JSON.parse(JSON.stringify(this.seats)));
      this.$emit("select", this.seatData.userCanDelete, this.seatData, this.itemRow, this.itemColumn);
    }
  },
  watch: {
    // seatData(newValue, oldValue) {
    //   console.log("new seat data: ", newValue);
    // }
  }
};
</script>

<style scoped>
/* .seat-item {
  margin-left: 6px;
  margin-right: 6px;
} */

/* .seat-item:after {
  content: "";
  position: absolute;
  top: 0;
  width: 50%;
  height: 100%;
  left: 50%;
  background: plum;
  z-index: -1;
} */

/* .seat-item a.seat {
  display: block;
   width: 100px;
  height: 100px; 
  border-radius: 50px;
  font-size: 20px;
  color: #fff;
  line-height: 100px;
  text-align: center;
  text-decoration: none;
  background: #000;
}
.seat-item a.seat:hover {
  color: #ccc;
  text-decoration: none;
  background: #333;
} */
</style>
